// extracted by mini-css-extract-plugin
export var banner = "_2j-0";
export var icon = "_2j-1";
export var message = "_2j-2";